import { API, METHODS } from '../constants';
import { fetchData } from '../utils/apiCalling';

const post = (url, body) => fetchData({ url, body, method: METHODS.POST });
export const listReprocessing = (body = {}) => post(API.REPROCESSING_LIST, body);
export const findReprocessingSources = (body) => post(API.REPROCESSING_SOURCES, body);
export const createReprocessing = (body) => post(API.REPROCESSING_CREATE, body);
export const actOnReprocessing = (body) => post(API.REPROCESSING_ACTION, body);
